import { Desktop, Moon, Palette, Sun } from "@phosphor-icons/react";
import { createAction } from "~/actions/registry";
import type { Action } from "~/actions/types";
import {
  getThemePreference,
  setThemePreference,
  type ThemePreference,
} from "~/foundation/theme/useTheme";

const section = (ctx: { t: (key: string) => string }) => ctx.t("Appearance");

function themeAction(
  preference: ThemePreference,
  label: string,
  icon: typeof Sun,
  shortcut: string[],
): Action {
  return createAction({
    id: `theme.${preference}`,
    name: (ctx) => ctx.t(label),
    section,
    icon,
    shortcut,
    keywords: "theme appearance colour color",
    selected: () => getThemePreference() === preference,
    perform: () => setThemePreference(preference),
  });
}

export const themeLight = themeAction("light", "Light", Sun, ["Shift", "L"]);
export const themeDark = themeAction("dark", "Dark", Moon, ["Shift", "D"]);
export const themeSystem = themeAction("system", "System", Desktop, ["Shift", "S"]);

export const appearanceAction = createAction({
  id: "theme",
  name: (ctx) => ctx.t("Appearance"),
  section,
  icon: Palette,
  keywords: "theme dark light system",
  children: [themeLight, themeDark, themeSystem],
});

export const themeActions: Action[] = [appearanceAction];
/** The leaves are exported too: shortcuts bind to them directly, not through the parent. */
export const themeLeafActions: Action[] = [themeLight, themeDark, themeSystem];
